/*
 * Restricted products must not reach the cart through the wishlist. The Wishlist Hero page
 * (/a/wishlist-hero/wishlist) is rendered by the app and only exposes the product link, so each card's
 * product is looked up and its "Add to bag" button is hidden when it carries a restricted tag.
 *
 * To restrict another brand/product group, add its product tag (lower case) to RESTRICTED_TAGS and hide its
 * wishlist hearts on the cards (see the data-no-wishlist handling in snippets/card-product.liquid,
 * globo.filter.product.liquid, new-pinned-card.liquid and product-splide-gallery.liquid).
 */
(function () {
  var RESTRICTED_TAGS = [
    'rolex_bespoke_product', // Rolex Bespoke
    'brand patek philippe' // Patek Philippe (enquiry-only)
  ];
  var cache = {};

  function isRestricted(path) {
    if (!cache[path]) {
      cache[path] = fetch(path + '.js')
        .then(function (r) {
          return r.ok ? r.json() : { tags: [] };
        })
        .then(function (p) {
          return (p.tags || []).some(function (tag) {
            return RESTRICTED_TAGS.indexOf(String(tag).toLowerCase()) !== -1;
          });
        })
        .catch(function () {
          // Unknown: leave the button hidden (see the CSS in theme.liquid) and retry later.
          delete cache[path];
          return null;
        });
    }
    return cache[path];
  }

  function hideAddToBag(card) {
    card.querySelectorAll('button').forEach(function (button) {
      if (/add to bag/i.test(button.textContent)) button.style.display = 'none';
    });
  }

  function process() {
    document.querySelectorAll('.wishlist-hero-list-card').forEach(function (card) {
      var link = card.querySelector('a[href*="/products/"]');
      if (!link) return;
      var path = new URL(link.href, window.location.origin).pathname;
      if (card.dataset.restrictedChecked === path) {
        // The app can re-render the button, so keep it hidden for known restricted cards.
        if (card.dataset.restricted === 'true') hideAddToBag(card);
        return;
      }
      card.dataset.restrictedChecked = path;
      isRestricted(path).then(function (restricted) {
        if (restricted === null) {
          delete card.dataset.restrictedChecked;
          return;
        }
        // data-restricted="false" is what reveals the button (CSS in theme.liquid).
        card.dataset.restricted = restricted ? 'true' : 'false';
        if (restricted) hideAddToBag(card);
      });
    });
  }

  new MutationObserver(process).observe(document.body, { childList: true, subtree: true });
  process();
})();
